// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44022":"614d0d3b","48464":"cdf4a4c6","74892":"400b130a","81432":"37348477"}[chunkId] + ".chunk.css";
};